'use strict';

/**
 * @ngdoc overview
 * @name v-sac-speak-to-advisor
 * @description
 * # Module
 */
angular.module('v-sac-speak-to-advisor', ['pascalprecht.translate', 'v-sac-speak-to-advisor.config', 'v-ui-components', 'ngDialog', 'ui.router', 'v-core.error', 'v.input-validation', 'v-core.vsa.http', 'v-core.gmt', 'v-core.config']);
'use strict';

angular.module('v-sac-speak-to-advisor').service('speakToAdvisorService', ['$http', 'speakToAdvisorConfig', '$log', function speakToAdvisorService($http, speakToAdvisorConfig, $log) {
    var _this = this;

    this.providedClientInfo = {};
    var REST_API_SERVER_AND_PATH = speakToAdvisorConfig.REST_API_SERVER_AND_PATH;
    var OC11_API_SERVER_AND_PATH = speakToAdvisorConfig.OC11_API_SERVER_AND_PATH;

    $log.debug('speakToAdvisorConfig = ', speakToAdvisorConfig);

    this.setProvidedClientInfo = function (clientInfo) {
        _this.providedClientInfo = clientInfo;
    };

    this.postForm = function (clientInfo, token, unity) {

        $log.debug('postForm - clientInfo = ', clientInfo);
        $log.debug('postForm - token = ', token);
        $log.debug('postForm - unity = ', unity);

        var submissionUrl = OC11_API_SERVER_AND_PATH + unity + '/lnk/json/cmnServiceJSON.jsp';

        if (token) submissionUrl += '?token=' + token;

        return $http({
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            url: submissionUrl,
            data: clientInfo
        });
    };

    this.checkAvailability = function () {
        return $http({
            method: 'GET',
            url: REST_API_SERVER_AND_PATH + 'businessinteraction/contactus/sac/availability/callmenow'
        });
    };
}]);
'use strict';

angular.module('v-sac-speak-to-advisor').constant('speakToAdvisorConstants', {
    gmt: {
        event: 'contact',
        eventAction: 'soumettre un formulaire',
        eventLabel: 'Parler à un représentant'
    }
});
'use strict';

var token = false; // eslint-disable-line
var recaptcha = null; // eslint-disable-line

angular.module('v-sac-speak-to-advisor').component('speakToAdvisorFormRes', {
    templateUrl: 'html/speak-to-advisor-form-res.html',
    controller: ['$translate', 'speakToAdvisorService', 'speakToAdvisorConfig', '$scope', '$state', 'ngDialog', '$log', '$window', function controller($translate, speakToAdvisorService, speakToAdvisorConfig, $scope, $state, ngDialog, $log, $window) {
        var _this = this;

        $log.debug('===== speakToAdvisorFormRes =====');
        this.data = {
            contactFirstname: '',
            contactLastName: '',
            companyName: '',
            phoneNumber: ''
        };

        var googleSiteKey = speakToAdvisorConfig.GOOGLE_RECAPTCHA;
        var reCaptchaInitialized = false;
        this.xlocale = speakToAdvisorService.providedClientInfo.lang;
        this.urlPage = speakToAdvisorService.providedClientInfo.urlPage;
        this.segmentName = speakToAdvisorService.providedClientInfo.segmentName;
        this.captchaLang = speakToAdvisorService.providedClientInfo.captchaLang;
        this.productId = speakToAdvisorService.providedClientInfo.productId;
        this.accountNumber = speakToAdvisorService.providedClientInfo.accountNumber;

        this.$onInit = function () {
            document.querySelector('.ngdialog.speak-to-advisor-app').classList.add('speak-to-advisor-residential');
        };

        this.toggleCallMeNow = function () {
            ngDialog.closeAll();
        };

        this.submit = function () {
            $log.debug('---- ResForm submit ---- ');
            angular.element(document.querySelector("input[name='callBackTelephone']")).val(_this.data.phoneNumber);

            // reset error message
            var errorMsg = angular.element(document.querySelector('.call-me-now__error-msg')),
                inputNumber = angular.element(document.querySelector('.call-me-now__number')),
                formElement = angular.element(document.querySelector('#call-me-now__form_copy')),
                formWrapper = angular.element(document.querySelector('.call-me-now')),
                successMsg = angular.element(document.querySelector('.call-me-now__success-msg'));

            errorMsg.empty();
            inputNumber.removeClass('error');
            errorMsg.removeClass('visible');

            // disable submit if reCAPTACHA is initialized and not checked
            if (reCaptchaInitialized && $window.grecaptcha.getResponse($window.recaptcha) === '') {
                // eslint-disable-line
                $log.debug('postForm - $window.grecaptcha.getResponse($window.recaptcha) = ', $window.grecaptcha.getResponse($window.recaptcha));
                errorMsg.html(angular.element(document.querySelector('#cmn_selectRecaptcha')).val());
                errorMsg.addClass('visible');
                return;
            }

            var serializedForm = $('#call-me-now__form').serialize(); // eslint-disable-line

            $log.debug('postForm - serializedForm = ', serializedForm);

            var postRequest = speakToAdvisorService.postForm(serializedForm, token, "residentiel");

            postRequest.then(function successCallback(response) {
                $log.debug('postForm - successCallback response = ', response);
                try {
                    response = response.data;
                    var error = false;
                    if (response.data.msg === 'msgNuméroTéléphoneInvalide') {
                        errorMsg.html(angular.element(document.querySelector('#cmn_invalidNumber')).val());
                        inputNumber.addClass('error');
                        errorMsg.addClass('visible');
                        error = true;
                    } else if (response.data.msg === 'msgNuméroTéléphoneManquant') {
                        errorMsg.html(angular.element(document.querySelector('#cmn_required')).val());
                        inputNumber.addClass('error');
                        errorMsg.addClass('visible');
                        error = true;
                    } else if (response.data.msg === 'msgErreurSoumissionCallMeNow') {
                        errorMsg.html(angular.element(document.querySelector('#cmn_notAvailable')).val());
                        errorMsg.addClass('visible');
                        error = true;
                    } else if (response.data.msg === 'msgCaptcha') {
                        errorMsg.html(angular.element(document.querySelector('#cmn_selectRecaptcha')).val());
                        formWrapper.addClass('call-me-now--recaptcha');
                        formElement.show();
                        successMsg.hide();
                        $scope.createRecaptcha();
                    } else if (response.data.key === 'contactus.callback.param.invalid') {
                        errorMsg.html(angular.element(document.querySelector('#cmn_invalidNumber')).val());
                        errorMsg.addClass('visible');
                        error = true;
                    } else if (response.data.statusCode === '400') {
                        errorMsg.html(angular.element(document.querySelector('#cmn_notAvailable')).val());
                        errorMsg.addClass('visible');
                        error = true;
                    } else if (response.data.msg === 'msgAppelEncours' || response.data.success) {
                        formWrapper.removeClass('call-me-now--recaptcha');
                        formElement.hide();
                        successMsg.show();
                    };
                    if (error) {
                        // If the Captcha is initialized but a new error occur we remove the captcha for the DOM
                        if (reCaptchaInitialized) {
                            formWrapper.removeClass('call-me-now--recaptcha');
                            $('#call-me-now-recaptcha').remove(); // eslint-disable-line
                            $window.recaptcha = null;
                            reCaptchaInitialized = false;
                        }
                    }
                } catch (err) {
                    errorMsg.html(angular.element(document.querySelector('#cmn_notAvailable')).val());
                    errorMsg.addClass('visible');
                }
            }, function errorCallback(err) {
                $log.debug('postForm - errorCallback -  err = ', err);
                errorMsg.html(angular.element(document.querySelector('#cmn_notAvailable')).val());
                errorMsg.addClass('visible');
            });
        };

        $scope.createRecaptcha = function () {
            if (reCaptchaInitialized === false) {
                reCaptchaInitialized = true;

                angular.element(document.querySelector('.call-me-now')).addClass('call-me-now--recaptcha');

                var reCaptchaDiv = document.createElement('div');
                reCaptchaDiv.setAttribute('id', 'call-me-now-recaptcha');
                reCaptchaDiv.setAttribute('class', 'g-recaptcha');

                document.getElementById('call-me-now__form_copy').appendChild(reCaptchaDiv);
                $window.recaptcha = $window.grecaptcha.render('call-me-now-recaptcha', { // eslint-disable-line
                    'sitekey': googleSiteKey,
                    'hl': _this.captchaLang,
                    'callback': function callback(resp) {
                        $window.token = resp;
                        angular.element(document.querySelector('#cmnCaptchaResponse')).val(resp);
                    }
                });
            }
        };
    }]
});
'use strict';

var token = false; // eslint-disable-line
var recaptcha = null; // eslint-disable-line

angular.module('v-sac-speak-to-advisor').component('speakToAdvisorForm', {
    templateUrl: 'html/speak-to-advisor-form.html',
    controller: ['$translate', 'speakToAdvisorService', 'speakToAdvisorConfig', '$state', '$log', '$rootScope', '$scope', '$window', function controller($translate, speakToAdvisorService, speakToAdvisorConfig, $state, $log, $rootScope, $scope, $window) {
        var _this = this;

        $log.debug('===== speakToAdvisorForm =====');
        this.data = {
            clientFirstName: '',
            clientLastName: '',
            companyNameCopy: '',
            phoneNumber: ''
        };
        var googleSiteKey = speakToAdvisorConfig.GOOGLE_RECAPTCHA;
        var reCaptchaInitialized = false;
        this.xlocale = speakToAdvisorService.providedClientInfo.lang;
        this.urlPage = speakToAdvisorService.providedClientInfo.urlPage;
        this.segmentName = speakToAdvisorService.providedClientInfo.segmentName;
        this.productId = speakToAdvisorService.providedClientInfo.productId;
        this.accountNumber = speakToAdvisorService.providedClientInfo.accountNumber;

        this.submit = function () {

            angular.element(document.querySelector("input[name='callBackTelephone']")).val(_this.data.phoneNumber);
            angular.element(document.querySelector("input[name='contactFirstName']")).val(_this.data.clientFirstName);
            angular.element(document.querySelector("input[name='contactLastName']")).val(_this.data.clientLastName);
            angular.element(document.querySelector("input[name='companyName']")).val(_this.data.companyNameCopy);
            $log.debug('reCaptchaInitialized = ', reCaptchaInitialized);
            if (reCaptchaInitialized && $window.grecaptcha.getResponse($window.recaptcha) === '') {
                // eslint-disable-line
                $log.debug('postForm - $window.grecaptcha.getResponse($window.recaptcha) = ', $window.grecaptcha.getResponse($window.recaptcha));
                return;
            }

            var serializedForm = $('#call-me-now__form').serialize(); // eslint-disable-line

            _this.data.phoneNumber = _this.data.phoneNumber.replace(/-/g, '');

            var postRequest = speakToAdvisorService.postForm(serializedForm, false, "affaires");

            postRequest.then(successCallback, errorCallback);
        };

        var successCallback = function successCallback(response) {
            $log.debug('postForm - successCallback = ', response);
            try {
                response = response.data;
                var error = false;
                $log.debug('postForm - successCallback STATUS = ', response.data.statusCode);

                if (response.data.msg === 'msgAppelEncours' || response.data.success) {
                    $state.go('confirmation');
                } else if (response.data.statusCode == "" || response.data.statusCode == "500") {
                    $rootScope.$broadcast('handleVError', [{ code: 'ERRORS.NETWORK' }]);
                    error = true;
                } else if (response.data.key === 'contactus.callback.param.invalid') {
                    $rootScope.$broadcast('handleVError', [{ code: 'ERRORS.INVALID' }]);
                    error = true;
                } else if (response.data.msg === 'msgCaptcha') {
                    $scope.createRecaptcha();
                } else if (response.data.statusCode == "400") {
                    $rootScope.$broadcast('handleVError', [{ code: 'ERRORS.INVALID' }]);
                    error = true;
                }
                if (error) {
                    // If the Captcha is initialized but a new error occur we remove the captcha for the DOM
                    if (reCaptchaInitialized) {
                        $('#call-me-now-recaptcha').remove(); // eslint-disable-line
                        $window.recaptcha = null;
                        reCaptchaInitialized = false;
                    }
                }
            } catch (err) {
                $log.debug('postForm - successCallback CATCH = ', err);
                $rootScope.$broadcast('handleVError', [{ code: 'ERRORS.GLOBAL' }]);
            }
        };

        var errorCallback = function errorCallback(response) {
            $log.debug('postForm - errorCallback = ', response);
            $rootScope.$broadcast('handleVError', [{ code: 'ERRORS.GLOBAL' }]);
        };

        $scope.createRecaptcha = function () {
            if (reCaptchaInitialized === false) {
                reCaptchaInitialized = true;

                angular.element(document.querySelector('.call-me-now')).addClass('call-me-now--recaptcha');

                var reCaptchaDiv = document.createElement('div');
                reCaptchaDiv.setAttribute('id', 'call-me-now-recaptcha');
                reCaptchaDiv.setAttribute('class', 'g-recaptcha');

                document.getElementById('call-me-now__form_copy').appendChild(reCaptchaDiv);
                $window.recaptcha = $window.grecaptcha.render('call-me-now-recaptcha', { // eslint-disable-line
                    'sitekey': googleSiteKey,
                    'hl': _this.captchaLang,
                    'callback': function callback(resp) {
                        $window.token = resp;
                        angular.element(document.querySelector('#cmnCaptchaResponse')).val(resp);
                    }
                });
            }
        };
    }]
});
'use strict';

angular.module('v-sac-speak-to-advisor').component('speakToAdvisorConfirmation', {
    templateUrl: 'html/speak-to-advisor-confirmation.html',
    controller: ['ngDialog', 'speakToAdvisorConstants', '$log', 'gmtService', function controller(ngDialog, speakToAdvisorConstants, $log, gmtService) {
        $log.debug('===== speakToAdvisorConfirmation =====');
        this.close = function () {
            ngDialog.close();
        };

        gmtService.sendGMTData(speakToAdvisorConstants.gmt);
    }]
});
'use strict';

angular.module('v-sac-speak-to-advisor').component('speakToAdvisorAppLauncher', {
    template: '<span id="speakToAdvisorTrigger" ng-show="$ctrl.sacOpen" href="" ng-click="$ctrl.launchApp()"><ng-transclude></ng-transclude></span>',
    replace: true,
    transclude: true,
    bindings: {
        language: '@',
        type: '@',
        urlPage: '@',
        accountNumber: '@',
        productId: '@',
        segmentName: '@',
        xlocale: '@'
    },
    controller: ['$rootScope', 'ngDialog', '$translate', '$state', 'speakToAdvisorService', '$log', function controller($rootScope, ngDialog, $translate, $state, speakToAdvisorService, $log) {
        var _this = this;

        $log.debug('===== speakToAdvisorAppLauncher =====');
        this.sacOpen = false;

        var defaultLanguage = this.language ? this.language : $translate.use();
        var defaultType = this.type ? this.type : "AFF";
        var captchaLang = defaultLanguage == 'fr' ? 'fr-CA' : 'en';

        if (defaultType === "AFF") {
            speakToAdvisorService.checkAvailability().then(function (result) {
                _this.sacOpen = result.data;
            }).catch(function (e) {
                $log.debug("Erro while checkAvailability = ", e);
            });
        } else {
            this.sacOpen = true;
        }

        $translate.use(defaultLanguage);
        $rootScope.locale = defaultLanguage;

        var clientInfo = {
            lang: defaultLanguage,
            type: defaultType,
            captchaLang: captchaLang,
            urlPage: this.urlPage,
            accountNumber: this.accountNumber,
            productId: this.productId,
            siteContext: this.siteContext,
            segmentName: this.segmentName
        };

        speakToAdvisorService.setProvidedClientInfo(clientInfo);

        this.launchApp = function () {
            if (this.type === 'RES') {
                $state.go('staRes');
            } else {
                $state.go('sta');
            }
            ngDialog.open({
                templateUrl: '<div ui-view="speakToAdvisorView" class="speakToAdvisorView"></div>',
                plain: true,
                closeByDocument: false,
                className: 'speak-to-advisor-app v-ui-components ngdialog-theme-default v-dialog v-form'
            });
        };

        $rootScope.$on('ShowCallMeNow', function () {
            $log.debug('On ShowCallMeNow');
            $state.go('staRes');
            ngDialog.open({
                templateUrl: '<div ui-view="speakToAdvisorView" class="speakToAdvisorView"></div>',
                plain: true,
                closeByDocument: false,
                className: 'speak-to-advisor-app v-ui-components ngdialog-theme-default v-dialog v-form'
            });
        });
    }]
});
'use strict';

angular.module('v-sac-speak-to-advisor').provider('speakToAdvisorConfig', ['appConfigProvider', 'APP_CONFIG', function speakToAdvisorConfig(appConfigProvider, APP_CONFIG) {
    var _this = this;

    var key = 'angular-app-v-sac-speak-to-advisor';

    this.appConfig = angular.merge({ i18n: {} }, APP_CONFIG, appConfigProvider.$get()[key]);

    this.$get = function () {
        return _this.appConfig;
    };
}]);
'use strict';

angular.module('v-sac-speak-to-advisor').config(['$translateProvider', '$windowProvider', 'ngDialogProvider', '$stateProvider', 'speakToAdvisorConfigProvider', '$logProvider', '$compileProvider', function ($translateProvider, $windowProvider, ngDialogProvider, $stateProvider, speakToAdvisorConfigProvider, $logProvider, $compileProvider) {
    var appConfig = speakToAdvisorConfigProvider.$get();
    var document = $windowProvider.$get().document;
    var lang = document.documentElement.getAttribute('lang') || 'fr';
    var isDebug = appConfig.DEBUG;

    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider.translations('en', appConfig.i18n.en);
    $translateProvider.translations('fr', appConfig.i18n.fr);
    $translateProvider.use(lang);

    $logProvider.debugEnabled(isDebug);
    $compileProvider.debugInfoEnabled(isDebug);

    $stateProvider.state('sta', {
        views: {
            speakToAdvisorView: { template: '<speak-to-advisor-form></speak-to-advisor-form>' }
        }
    }).state('staRes', {
        views: {
            speakToAdvisorView: { template: '<speak-to-advisor-form-res></speak-to-advisor-form-res>' }
        }
    }).state('confirmation', {
        views: {
            speakToAdvisorView: { template: '<speak-to-advisor-confirmation></speak-to-advisor-confirmation>' }
        }
    });

    ngDialogProvider.setDefaults({
        className: 'v-ui-components ngdialog-theme-default v-dialog',
        plain: false,
        showClose: true,
        closeByDocument: true,
        closeByEscape: true
    });
}]);
(function(module) {
try {
  module = angular.module('v-sac-speak-to-advisor');
} catch (e) {
  module = angular.module('v-sac-speak-to-advisor', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('index-vsr.html',
    '<!DOCTYPE html><html version="{{ version }}" lang="fr"><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Speak to advisor</title><link rel="stylesheet" href="/a/few/frg/tiweb.static.core/latest/css/fonts.css"><link rel="stylesheet" href="https://videotron.com/residentiel/static/css/videotron-core.css"><link rel="stylesheet" href="https://videotron.com/residentiel/static/css/videotron-tmo.css"></head><body><div class="popup-parent-position ng-scope"><form id="call-me-now__form" action="/residentiel/include/callMeNow/#" class="ng-pristine ng-valid" ng-submit="submit()"><input name="_dyncharset" value="utf-8" type="hidden" autocomplete="off"><input name="_dynSessConf" value="2142486111214901323" type="hidden" autocomplete="off"><div><speak-to-advisor-app-launcher id="speak-to-advisor-app" language="fr" type="RES" url-page="https://uat1-vcom-cl-prd.ext.videotron.com/residentiel/b/mobilite/forfaits/forfait-mobiles/N-15obfmzZmvgqiv" account-number="" product-id="" class="speak-to-advisor-app" segment-name="Service"><span><a href="#">Click me to open popoup</a></span></speak-to-advisor-app-launcher></div><input id="callBackTelephone" name="callBackTelephone" value="" type="hidden" autocomplete="off"><input name="_D:callBackTelephone" value=" " type="hidden" autocomplete="off"> <input id="cmnCaptchaResponse" name="captcha" value="" type="hidden" autocomplete="off"><input name="_D:captcha" value=" " type="hidden" autocomplete="off"> <input name="segmentName" value="Service" type="hidden" autocomplete="off"><input name="_D:segmentName" value=" " type="hidden" autocomplete="off"> <input name="clientType" value="RES" type="hidden" autocomplete="off"><input name="_D:clientType" value=" " type="hidden" autocomplete="off"> <input name="urlPage" value="https://uat1-vcom-cl-prd.ext.videotron.com/residentiel/b/mobilite/forfaits/forfait-mobiles/N-15obfmzZmvgqiv" type="hidden" autocomplete="off"><input name="_D:urlPage" value=" " type="hidden" autocomplete="off"> <input name="callMeNowService" value="callMeNowService" type="hidden" autocomplete="off"><input name="_D:callMeNowService" value=" " type="hidden" autocomplete="off"> <input name="/videotron/commerce/handler/CallMeNowFormHandler.siteContext" value="/residentiel" type="hidden" autocomplete="off"><input name="_D:/videotron/commerce/handler/CallMeNowFormHandler.siteContext" value=" " type="hidden" autocomplete="off"> <input name="/videotron/commerce/handler/CallMeNowFormHandler.xlocale" value="fr" type="hidden" autocomplete="off"><input name="_D:/videotron/commerce/handler/CallMeNowFormHandler.xlocale" value=" " type="hidden" autocomplete="off"> <input name="_DARGS" value="/vtrn-res/include/callMeNow/callMeNowController.jsp" type="hidden" autocomplete="off"></form></div><script src="/a/few/frg/v-few-frg-loader/latest/js/fragmentLoader.js"></script><script>vlFragmentLoader\n' +
    '            .init({waitForDocReady: true, byType: {angularjs: {singleBootstrap: true}}})\n' +
    '            .loadIntegrationPoints([\'common\', \'vcom-res-sac-speak-to-advisor\']);</script><script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&amp;render=explicit" async="" defer=""></script><script src="https://fe.videotron.com/a/few/libs/vendors/jquery/3.2.1/jquery.min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/jquery.matchHeight/0.7.2/jquery.matchHeight-min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/slick-carousel/1.6.0/slick.min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/angular.js/1.5.11/angular.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/angular.js/1.5.11/angular-aria.min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/angular.js/1.5.11/angular-animate.min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/angular.js/1.5.11/angular-touch.min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/angular.js/1.5.11/angular-messages.min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/angular.js/1.5.11/angular-sanitize.min.js"></script><script src="https://fe.videotron.com/a/few/libs/vendors/angular-translate/2.15.2/angular-translate.min.js"></script></body></html>');
}]);
})();

(function(module) {
try {
  module = angular.module('v-sac-speak-to-advisor');
} catch (e) {
  module = angular.module('v-sac-speak-to-advisor', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('index.html',
    '<!DOCTYPE html><html version="{{ version }}" lang="fr"><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Speak to advisor</title><script src="https://fe.videotron.net/a/few/libs/vendors/jquery/3.2.1/jquery.min.js"></script><link rel="stylesheet" href="/a/few/frg/tiweb.static.core/latest/css/fonts.css"></head><body ng-app="v-sac-speak-to-advisor"><form id="call-me-now__form" action="/affaires/global/#" class="ng-pristine ng-valid"><input name="_dyncharset" value="UTF8" type="hidden" autocomplete="off"><input name="_dynSessConf" value="6825033779401754660" type="hidden" autocomplete="off"><speak-to-advisor-app-launcher id="speak-to-advisor-app" type="AFF" language="fr" url-page="videotron.com/affaires" account-number="1234567890" product-id="Samsung" segment-name="Vente" class="speak-to-advisor-app"><a href="#">Click me to open popoup</a></speak-to-advisor-app-launcher><input id="callBackTelephone" name="callBackTelephone" value="514-551-5151" type="hidden" autocomplete="off"><input name="_D:callBackTelephone" value=" " type="hidden" autocomplete="off"> <input id="cmnCaptchaResponse" name="captcha" value="" type="hidden" autocomplete="off"><input name="_D:captcha" value=" " type="hidden" autocomplete="off"> <input name="clientType" type="hidden" value="AFF" autocomplete="off"> <input name="_D:clientType" type="hidden" value=" " autocomplete="off"> <input name="segmentName" value="Vente" type="hidden" autocomplete="off"><input name="_D:segmentName" value=" " type="hidden" autocomplete="off"> <input name="urlPage" value="https://dev4-vcom-cl-prd.ext.videotron.com/affaires/parlons-affaires" type="hidden" autocomplete="off"><input name="_D:urlPage" value=" " type="hidden" autocomplete="off"> <input name="callMeNowService" value="callMeNowService" type="hidden" autocomplete="off"><input name="_D:callMeNowService" value=" " type="hidden" autocomplete="off"> <input name="/videotron/commerce/handler/CallMeNowFormHandler.siteContext" value="/affaires" type="hidden" autocomplete="off"><input name="_D:/videotron/commerce/handler/CallMeNowFormHandler.siteContext" value=" " type="hidden" autocomplete="off"> <input name="/videotron/commerce/handler/CallMeNowFormHandler.xlocale" value="fr" type="hidden" autocomplete="off"><input name="_D:/videotron/commerce/handler/CallMeNowFormHandler.xlocale" value=" " type="hidden" autocomplete="off"> <input name="companyName" value="safsafsafsaf" type="hidden" autocomplete="off"><input name="_D:companyName" value=" " type="hidden" autocomplete="off"> <input name="contactFirstName" value="" type="hidden" autocomplete="off"><input name="_D:contactFirstName" value=" " type="hidden" autocomplete="off"> <input name="contactLastName" value="fsafsafsafsaf" type="hidden" autocomplete="off"><input name="_D:contactLastName" value=" " type="hidden" autocomplete="off"> <input name="_DARGS" value="/vtrn/global/footerContact.jsp" type="hidden" autocomplete="off"><script>var onloadCallback = function() {\n' +
    '            console.log(\'recaptcha ready\');\n' +
    '        }</script><script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" async defer="defer"></script></form><script type="text/javascript">var lang = location.search.split(\'lang=\')[1];\n' +
    '    if (lang) {\n' +
    '        var element = document.getElementById("speak-to-advisor-app");\n' +
    '        element.setAttribute("language",  lang);\n' +
    '    }</script></body></html>');
}]);
})();

(function(module) {
try {
  module = angular.module('v-sac-speak-to-advisor');
} catch (e) {
  module = angular.module('v-sac-speak-to-advisor', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('html/speak-to-advisor-confirmation.html',
    '<div class="container v-long-form"><section class="v-form-header"><h1>{{ \'SAC.STA.TITLE\' | translate }}</h1></section><section><div class="v-icon-check-circle icon-check-success"></div><br><div class="center">{{ \'SAC.STA.CONFIRMATION.MESSAGE_PART1\' | translate }}</div><br><div class="center">{{ \'SAC.STA.CONFIRMATION.MESSAGE_PART2\' | translate }}</div></section><section><div class="v-action-buttons"><input type="submit" class="submit-btn" ng-click="$ctrl.close()" value="{{ \'SAC.STA.CONFIRMATION.BUTTON_CLOSE\' | translate }}"></div></section></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('v-sac-speak-to-advisor');
} catch (e) {
  module = angular.module('v-sac-speak-to-advisor', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('html/speak-to-advisor-form-res.html',
    '<div class="v-short-form"><global-errors></global-errors><div class="popup-parent-position"><div class="call-me-now call-me-now--opened" ng-class="{\'call-me-now--opened\' : opened}" style=""><div class="call-me-now__img"><img src="https://videotron.com/residentiel/static/img/callMeNow/res-contact-photo_640x640.png" alt="Call me now"></div><div class="info"><img class="call-me-now__close" src="https://videotron.com/residentiel/static/img/callMeNow/alert-close-gray.svg" alt="close alert" tabindex="0" ng-click="$ctrl.toggleCallMeNow()" role="button"><h2>{{ \'SAC.STA.RESIDENTIAL.TITLE\' | translate }}</h2><p>{{ \'SAC.STA.RESIDENTIAL.MESSAGE\' | translate }}</p><form name="form" id="call-me-now__form_copy" ng-submit="form.$valid && $ctrl.submit()" novalidate><div class="call-me-now__form-group-container"><div class="call-me-now__form-group"><v-input name="phoneNumber" ng-model="$ctrl.data.phoneNumber" v-input-validate="phone" placeholder="{{ \'SAC.STA.PHONE_NUMBER\' | translate }}" maxlength="12" required label-description=""></v-input><v-errors for="form.phoneNumber" class="call-me-now__error-msg"></v-errors></div><div class="call-me-now__form-group"><button type="submit" class="btn btn--dark btn--medium">{{ \'SAC.STA.SUBMIT\' | translate }}</button></div></div><input name="_DARGS" value="/vtrn-res/include/callMeNow/callMeNowController.jsp" type="hidden" autocomplete="off"></form><input type="hidden" id="cmn_areYouRobot" value="{{ \'ERRORS.VSR.cmn_areYouRobot\' | translate }}" autocomplete="off"> <input type="hidden" id="cmn_notARobot" value="{{ \'ERRORS.VSR.cmn_notARobot\' | translate }}" autocomplete="off"> <input type="hidden" id="cmn_notAvailable" value="{{ \'ERRORS.VSR.cmn_notAvailable\' | translate }}" autocomplete="off"> <input type="hidden" id="cmn_invalidNumber" value="{{ \'ERRORS.VSR.cmn_invalidNumber\' | translate }}" autocomplete="off"> <input type="hidden" id="cmn_required" value="{{ \'ERRORS.VSR.cmn_required\' | translate }}" autocomplete="off"> <input type="hidden" id="cmn_selectRecaptcha" value="{{ \'ERRORS.VSR.cmn_selectRecaptcha\' | translate }}" autocomplete="off"><div class="call-me-now__success-msg">{{ \'SAC.STA.RESIDENTIAL.SUCCESS\' | translate }}</div></div></div></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('v-sac-speak-to-advisor');
} catch (e) {
  module = angular.module('v-sac-speak-to-advisor', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('html/speak-to-advisor-form.html',
    '<div class="v-short-form"><global-errors></global-errors><div class="v-form-header"><h1>{{ \'SAC.STA.TITLE\' | translate }}</h1><p>{{ \'SAC.STA.MESSAGE\' | translate }}</p></div><section><form name="form" id="call-me-now__form_copy" ng-submit="form.$valid && $ctrl.submit()" novalidate><div class="row"><div class="columns col-12"><v-input name="clientLastName" label="{{ \'SAC.STA.LAST_NAME\' | translate }}" ng-model="$ctrl.data.clientLastName" v-input-validate="genericName" maxlength="50" required></v-input><v-errors for="form.clientLastName"></v-errors></div></div><div class="row"><div class="columns col-12"><v-input name="clientFirstName" label="{{ \'SAC.STA.FIRST_NAME\' | translate }}" ng-model="$ctrl.data.clientFirstName" v-input-validate="genericName" maxlength="50" required></v-input><v-errors for="form.clientFirstName"></v-errors></div></div><div class="row"><div class="columns col-12"><v-input name="companyNameCopy" label="{{ \'SAC.STA.BUSINESS_NAME\' | translate }}" ng-model="$ctrl.data.companyNameCopy" v-input-validate="genericName" maxlength="50" required></v-input><v-errors for="form.companyNameCopy"></v-errors></div></div><div class="row"><div class="columns col-12"><v-input name="phoneNumber" label="{{ \'SAC.STA.PHONE_NUMBER\' | translate }}" ng-model="$ctrl.data.phoneNumber" v-input-validate="phone" maxlength="12" required label-description=""></v-input><v-errors for="form.phoneNumber"></v-errors></div></div><div class="row"><div class="v-action-buttons columns col-12"><input type="submit" class="submit-btn" value="{{ \'SAC.STA.SUBMIT\' | translate }}"></div></div></form></section></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('v-sac-speak-to-advisor');
} catch (e) {
  module = angular.module('v-sac-speak-to-advisor', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('html/errors/global-errors.html',
    '<div class="v-generic-message-error" ng-repeat="error in $ctrl.errors"><h3>{{error.code + \'.TITLE\' | translate}}</h3><p>{{error.code + \'.DESC\' | translate}}</p></div>');
}]);
})();

angular.module("v-sac-speak-to-advisor.config", [])

.constant("APP_CONFIG", {
	"REST_API_SERVER_AND_PATH": "/rest/api/",
	"OC11_API_SERVER_AND_PATH": "https://videotron.com/",
	"DEBUG": false
})

.constant("version", "1.1.3")

;